import React from 'react'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import Constant from '../../Constant.js'
import axios from 'axios'
import moment from 'moment'
import MUIDataTable from 'mui-datatables'
import Loader from '../../common/Loader.js'
import { write, utils } from 'xlsx'

class MinaReport extends React.Component {
  state = {
    country_list: [],
    typeTagList: [],
    Data: [],
    reportUrl: '',
    isSearching: false,

    // filters
    bookingStatus: '',
    country: '',

    chaletList: [],

    start_date: moment().subtract(1, 'months').format('YYYY-MM-DD'),
    end_date: moment().format('YYYY-MM-DD'),
    typeTag: '',
    type: 'cruise',
  }

  componentDidMount() {
    this.getCountries()
    this.setState({
      typeTagList: Constant.getTypeTags(),
    })
  }

  getCountries = async () => {
    await axios
      .get(Constant.getAPI() + '/multi-country/list-countries?show_all_countries=true', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name:
            localStorage.getItem('loged_In_role') === 'super-admin'
              ? ''
              : `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res?.data?.success) {
          this.setState({
            country_list: res.data.data,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  getBookings = async () => {
    if (moment(this.state.start_date).isAfter(moment(this.state.end_date))) {
      Swal.fire('Invalid Date!', '', 'error')
      return
    }
    this.setState({ isSearching: true })

    const dateDMY1 = moment(this.state.start_date).format('MM/DD/YYYY')
    const dateDMY2 = moment(this.state.end_date).format('MM/DD/YYYY')

    let data = {
      bookingStatus: this.state.bookingStatus ? this.state.bookingStatus : null,
      country: this.state.country,
      typeTag: this.state.typeTag,
      type: this.state.type,
    }

    if (dateDMY1 && dateDMY1 != 'Invalid date') data.bookingDateFrom = dateDMY1
    if (dateDMY2 && dateDMY2 != 'Invalid date') data.bookingDateTo = dateDMY2

    await axios
      .post(Constant.getAPI() + `/reports/mina-report`, data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((response) => {
        this.setState({
          Data: response?.data?.data?.data,
        })
      })
      .catch((err) => {
        Swal.fire({
          title: err?.response?.data?.message || err?.response?.data?.data,
          icon: 'error',
          text: err?.response?.data?.data?.details[0]?.message,
          type: 'error',
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ok',
        })
      })
      .finally(() => {
        this.setState({
          isSearching: false,
        })
      })
  }

  checkDateDifference(date1, date2) {
    // Parse the dates using Moment.js
    const momentDate1 = moment(date1, 'YYYY-MM-DD')
    const momentDate2 = moment(date2, 'YYYY-MM-DD')

    // Calculate the difference in months
    const diffMonths = momentDate2.diff(momentDate1, 'months')
    // Compare the difference with 1
    if (diffMonths > 1) {
      return true
    } else {
      return false
    }
  }

  handleChange = (event) => {
    event.persist()

    this.setState(
      {
        [event?.target?.name]: event?.target?.value,
      },
      () => {
        if (
          (event?.target?.name == 'start_date' || event?.target?.name == 'end_date') &&
          this.checkDateDifference(this.state.start_date, this.state.end_date)
        ) {
          if (event?.target?.name == 'start_date') {
            this.setState({
              end_date: moment(this.state.start_date, 'YYYY-MM-DD').add(1, 'months').format('YYYY-MM-DD'),
            })
          } else {
            this.setState({
              start_date: moment(this.state.end_date, 'YYYY-MM-DD').subtract(1, 'months').format('YYYY-MM-DD'),
            })
          }
        }
      }
    )

    if (event?.target?.name == 'country') {
      this.setState({
        chaletList: [],
        chaletId: '',
      })

      if (event.target.value != '') {
        this.getChaletList(event.target.value)
      }
    }
  }

  searchData = async () => {
    this.setState({
      Data: [],
    })
    this.getBookings()
  }

  clearSearch = async () => {
    this.setState({
      bookingStatus: '',
      country: '',
      typeTag: '',

      start_date: moment().subtract(1, 'months').format('YYYY-MM-DD'),
      end_date: moment().format('YYYY-MM-DD'),

      Data: [],
    })
  }

  render() {
    const columns = [
      {
        name: 'COUNTRY',
        label: 'Country',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'ISSUE_DATE',
        label: 'Issue Date',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) =>
            value ? <div style={{ textWrap: 'nowrap' }}>{moment(value).format('YYYY-MM-DD')}</div> : '--',
        },
      },
      {
        name: 'BOOKING_DATE',
        label: 'Booking Date',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) =>
            value ? <div style={{ textWrap: 'nowrap' }}>{moment(value).format('YYYY-MM-DD')}</div> : '--',
        },
      },
      {
        name: 'BOOKING_STATUS',
        label: 'Booking Status',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'ORDER_NUMBER',
        label: 'Order Number',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'TYPE',
        label: 'Booking Type',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'NAME_EN',
        label: 'Name English',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'TYPE_TAG',
        label: 'Booking tag type',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'COUNT',
        label: 'Count',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'PICKUP',
        label: 'Pickup',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'CUSTOMER_NAME',
        label: 'Customer Name',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'CUSTOMER_PHONE',
        label: 'Customer Phone',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'COUPON_CODE',
        label: 'Applied Coupon',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => value || '--',
        },
      },
      {
        name: 'TOTAL_AMOUNT',
        label: 'Total Amount',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'SERVICE_AMOUNT',
        label: 'Service Amount',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'DISCOUNT_AMOUNT',
        label: 'Discount Amount',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'WALLET_AMOUNT',
        label: 'Wallet Applied Amount',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => value || '--',
        },
      },
      {
        name: 'DELIVERY_CHARGE',
        label: 'Delivery Charge',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => value || '--',
        },
      },
      {
        name: 'VAT_PER',
        label: 'Vat %',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return value
          },
        },
      },
      {
        name: 'VAT_AMOUNT',
        label: 'Vat Amount',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return value
          },
        },
      },
      {
        name: 'CRUISE_COMMISSION',
        label: 'Cruise Comission',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return value
          },
        },
      },
      {
        name: 'CRUISE_COMMISSION_AMOUNT',
        label: 'Cruise Commission Amount',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return value
          },
        },
      },
      {
        name: 'ADD_ON_AMOUNT',
        label: 'AddOn Amount',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return value
          },
        },
      },
      {
        name: 'RESTAURANT_AMOUNT',
        label: 'Restaurant Amount',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return value
          },
        },
      },
      {
        name: 'RESTAURANT_COMMISSION',
        label: 'Restaurant Commission',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return value
          },
        },
      },
      {
        name: 'RESTAURANT_COMMISSION_AMOUNT',
        label: 'Restaurant Commission Amount',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return value
          },
        },
      },
      {
        name: 'STORE_AMOUNT',
        label: 'Store Amount',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return value
          },
        },
      },
      {
        name: 'STORE_COMMISSION',
        label: 'Store Commission',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return value
          },
        },
      },
      {
        name: 'STORE_COMMISSION_AMOUNT',
        label: 'Store Commission Amount',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return value
          },
        },
      },
      {
        name: 'LIMO_AMOUNT',
        label: 'Limo Amount',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return value
          },
        },
      },
      {
        name: 'LIMO_COMMISSION',
        label: 'Limo Commission',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return value
          },
        },
      },
      {
        name: 'LIMO_COMMISSION_AMOUNT',
        label: 'Limo Commission Amount',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return value
          },
        },
      },
      {
        name: 'CATERING_AMOUNT',
        label: 'Catering Amount',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return value
          },
        },
      },
      {
        name: 'CATERING_COMMISSION',
        label: 'Catering Commission',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return value
          },
        },
      },
      {
        name: 'CATERING_COMMISSION_AMOUNT',
        label: 'Catering Commission Amount',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return value
          },
        },
      },
    ]

    const options = {
      filter: false,
      filterType: 'dropdown',
      viewColumns: false,
      print: false,
      download: true,
      downloadOptions: {
        filename: 'Bookings',
      },
      onDownload: (buildHead, buildBody, columns, values) => {
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
        const fileExtension = '.xlsx'
        const fileName = `Bookings`

        const json = values.reduce((result, val) => {
          const temp = {}
          val.data.forEach((v, idx) => {
            temp[columns[idx].name] = v
          })
          result.push(temp)
          return result
        }, [])

        const ws = utils.json_to_sheet(json)
        const wb = { Sheets: { data: ws }, SheetNames: ['data'] }
        const excelBuffer = write(wb, { bookType: 'xlsx', type: 'array' })
        const blob = new Blob([excelBuffer], { type: fileType })
        const file = new File([blob], fileName + fileExtension, { type: fileType })

        const downloadLink = document.createElement('a')
        downloadLink.href = URL.createObjectURL(file)
        downloadLink.download = file.name

        downloadLink.click()

        // cancel default  CSV download from table
        return false
      },
      selectableRows: 'none',
      textLabels: {
        body: {
          noMatch: this.state.isSearching ? <Loader open={this.state.isSearching} /> : 'Sorry, No data Found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
    }

    return (
      <div className="pcoded-inner-content">
        <div className="main-body">
          <div className="page-wrapper">
            <div className="page-header">
              <div className="row align-items-end">
                <div className="col-lg-8">
                  <div className="page-header-title">
                    <div className="d-inline">
                      <h4>Mina Report</h4>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="page-header-breadcrumb">
                    <ul className="breadcrumb-title">
                      <li className="breadcrumb-item">
                        <Link to="/">
                          <i className="feather icon-home"></i>{' '}
                        </Link>
                      </li>
                      <li className="breadcrumb-item active">Mina Report</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="page-body">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card card-border-default">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Booking Type</label>
                            <div className="col-sm-9">
                              <select
                                name="type"
                                className="form-control"
                                value={this.state.type}
                                onChange={this.handleChange}
                              >
                                {/* <option value={''}>All</option> */}
                                <option value={'cruise'}>Cruise</option>
                                <option value={'chalet'}>Chalet</option>
                                <option value={'store'}>Store</option>
                                <option value={'event'}>Event</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        {this.state.type !== 'store' && (
                          <>
                            <div className="col-md-4">
                              <div className="form-group row">
                                <label className="col-sm-3 col-form-label">Booking Status</label>
                                <div className="col-sm-9">
                                  <select
                                    name="bookingStatus"
                                    className="form-control"
                                    value={this.state.bookingStatus}
                                    onChange={this.handleChange}
                                  >
                                    <option value={''}>All</option>
                                    <option value={'Pending'}>Pending</option>
                                    <option value={'Successful'}>Successful</option>
                                    <option value={'Cancelled'}>Cancelled</option>
                                    <option value={'Confirmed'}>Confirmed</option>
                                    <option value={'Postponed'}>Postponed</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                          </>
                        )}
                        {this.state.type === 'store' && (
                          <>
                            <div className="col-md-4">
                              <div className="form-group row">
                                <label className="col-sm-3 col-form-label">Booking Status</label>
                                <div className="col-sm-9">
                                  <select
                                    name="bookingStatus"
                                    className="form-control"
                                    value={this.state.bookingStatus}
                                    onChange={this.handleChange}
                                  >
                                    <option value={''}>All</option>
                                    <option value={'In Progress'}>In Progress</option>
                                    <option value={'Delivered'}>Delivered</option>
                                    <option value={'Cancelled'}>Cancelled</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                          </>
                        )}
                        <div className="col-md-4">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Country</label>
                            <div className="col-sm-9">
                              <select
                                name="country"
                                className="form-control"
                                value={this.state.country}
                                onChange={this.handleChange}
                              >
                                <option value={''}>All</option>
                                {this.state.country_list.map((country) => (
                                  <option
                                    value={country.country_short_name}
                                    key={country.country_short_name}
                                  >
                                    {country.country_name_en + '/' + country.country_name_ar}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Tag Type</label>
                            <div className="col-sm-9">
                              <select
                                name="typeTag"
                                className="form-control"
                                onChange={this.handleChange}
                                value={this.state.typeTag}
                              >
                                <option value={''}>All</option>
                                {this.state?.typeTagList?.length > 0
                                  ? this.state.typeTagList.map((tag) => (
                                      <option
                                        value={tag}
                                        key={tag}
                                      >
                                        {tag}
                                      </option>
                                    ))
                                  : null}
                              </select>
                            </div>
                          </div>
                        </div>
                        <div
                          className="col-12"
                          style={{ borderBottom: '1px solid #ddd', marginBottom: 15 }}
                        ></div>
                        <div className="col-md-4">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Created Start Date</label>
                            <div className="col-sm-9">
                              <input
                                type="date"
                                id="date"
                                name="start_date"
                                className="form-control"
                                onChange={this.handleChange}
                                value={this.state.start_date}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Created End Date</label>
                            <div className="col-sm-9">
                              <input
                                type="date"
                                max={moment().format('YYYY-MM-DD')}
                                id="date"
                                name="end_date"
                                className="form-control"
                                onChange={this.handleChange}
                                value={this.state.end_date}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="row">
                            <div
                              className="col-6"
                              style={{ color: 'red' }}
                            >
                              You can get maximum 1 months rocords at a time
                            </div>
                            <div className="text-right col-6">
                              {this.state.isSearching ? (
                                <button
                                  className="btn btn-grd-disabled"
                                  disabled
                                  style={{ width: 150 }}
                                >
                                  Searching...!
                                </button>
                              ) : (
                                <>
                                  <button
                                    style={{ width: 150 }}
                                    className="btn btn-inverse waves-effect m-r-10"
                                    onClick={this.clearSearch}
                                  >
                                    Clear
                                  </button>
                                  <button
                                    style={{ width: 150 }}
                                    onClick={this.searchData}
                                    className="btn btn-inverse waves-effect"
                                  >
                                    Search
                                  </button>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="page-body">
              <div className="row">
                <div className="col-12">
                  <div className="card card-border-default">
                    <div className="card-block">
                      <div className="dt-responsive table-responsive">
                        <MUIDataTable
                          title={'Mina Report'}
                          className="table-responsive"
                          data={this.state.Data}
                          columns={columns}
                          options={options}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default MinaReport
